import { InventoryMapper } from '../../../../common/inventory/mappers/InventoryMapper';
import { SeverityMapper } from '../../../../common/mappers/SeverityMapper';
import { Preset } from '../../../../common/models/valueObjects/Preset';
import { GQLIdEncoder } from '../../../../common/utils/GQLIdEncoder';
import { OrganizationPrintData } from '../models/OrganizationPrintData';
import { Issue } from '../models/valueObjects/Issue';

type IssueBuffer = {
  number: number;
  title: string;
  shortExplanation: string;
  severity: string;
  numberOfProjects: number;
  numberOfSlots: number;
};

export class OrganizationPrintMapper {
  private readonly severityMapper = new SeverityMapper();
  private readonly inventoryMapper = new InventoryMapper();
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any, tags: string[], projects: Preset[], profiles: Preset[]): OrganizationPrintData {
    const issues = this.mapIssues(data.vulnerabilities);
    const inventory = this.inventoryMapper.mapGQLModel(data.inventory);

    return new OrganizationPrintData(data.name, this.mapPresetIds(projects), tags, this.mapPresetIds(profiles), issues, inventory);
  }

  private mapIssues(issues: any): Issue[] | null {
    if (!issues || !issues.edges) return null;
    const issuesMap: { [key: number]: IssueBuffer } = {};
    for (const { node } of issues.edges) {
      if (!issuesMap[node.number]) {
        issuesMap[node.number] = {
          number: node.number,
          title: node.title,
          shortExplanation: node.shortExplanation,
          severity: node.severity,
          numberOfSlots: 0,
          numberOfProjects: 0,
        };
      }
      issuesMap[node.number].numberOfSlots += node.numberOfSlots;
      issuesMap[node.number].numberOfProjects++;
    }
    return Object.values(issuesMap).map((i) => {
      return new Issue(i.number, i.title, i.shortExplanation, this.severityMapper.mapSeverity(i.severity), i.numberOfProjects, i.numberOfSlots);
    });
  }

  private mapPresetIds(presets: Preset[]): Preset[] {
    return presets.map((p) => new Preset(this.gqlIdEncoder.decode(p.getId()).toString(), p.getLabel(), p.getCategory()));
  }
}
